if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"frontend","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(0765|1439|6891|8876)|2((025|433|972)0|5874|7207|8485)|3(0402|2620|6773|6912)|4(0407|2842|8196|9869)|5(044|1791|8202|8853)|6(0299|1477|2448|5314|5911)|7(324|47|7214|750|8795|9282)|8(2707|4195|7148|9803)|9(1282|3997|462))$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}